import { render } from "./exceptionalArticlesSerialNumber.vue?vue&type=template&id=1b049077"
import script from "./exceptionalArticlesSerialNumber.vue?vue&type=script&lang=js"
export * from "./exceptionalArticlesSerialNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__